import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from "react";
import { useBanner } from "../contexts";
import { commonRequest } from "@devowl-wp/utils";
import { getOptionsFromWindow } from "../utils";
import { locationRestConsentGet } from "../wp-api";

/**
 * Populate the banner depending on the active action. This handles the following things:
 *
 * - History
 * - Change
 * - Revoke
 */
function useBannerActionType() {
  var banner = useBanner();
  var consent = banner.consent,
      groups = banner.groups,
      tcf = banner.tcf,
      activeAction = banner.activeAction,
      selectHistoryEntry = banner.selectHistoryEntry,
      setHistory = banner.setHistory; // Save the current consent and group settings to restore

  var _useState = useState({
    consent: consent,
    groups: groups,
    tcf: tcf
  }),
      _useState2 = _slicedToArray(_useState, 2),
      originalConsent = _useState2[0],
      setOriginalConsent = _useState2[1]; // Listen to consent changes and save it as original consent (only when non-history)


  useEffect(function () {
    if (!activeAction) {
      setOriginalConsent({
        consent: consent,
        groups: groups,
        tcf: tcf
      });
    }
  }, [consent, groups, tcf, activeAction]);
  useEffect(function () {
    function fetch() {
      return _fetch.apply(this, arguments);
    }

    function _fetch() {
      _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _getOptionsFromWindow, restNamespace, restRoot, restQuery, result, _result, _result$, _groups2, decision, _tcf2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _getOptionsFromWindow = getOptionsFromWindow(), restNamespace = _getOptionsFromWindow.restNamespace, restRoot = _getOptionsFromWindow.restRoot, restQuery = _getOptionsFromWindow.restQuery;
                _context.next = 3;
                return commonRequest({
                  location: locationRestConsentGet,
                  options: {
                    restNamespace: restNamespace,
                    restRoot: restRoot,
                    restQuery: restQuery
                  }
                });

              case 3:
                result = _context.sent;
                setHistory(result); // Initially select first item

                if (result.length) {
                  _result = _slicedToArray(result, 1), _result$ = _result[0], _groups2 = _result$.groups, decision = _result$.decision, _tcf2 = _result$.tcf;
                  selectHistoryEntry(_groups2, decision, _tcf2);
                } else {
                  selectHistoryEntry([], []);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetch.apply(this, arguments);
    }

    if (activeAction === "history") {
      // Save state of original consent
      setOriginalConsent({
        consent: consent,
        groups: groups,
        tcf: tcf
      });
      fetch();
    } else {
      // If we close the history, restore the original state
      var _groups = originalConsent.groups,
          consentGroups = originalConsent.consent.groups,
          _tcf = originalConsent.tcf;
      selectHistoryEntry === null || selectHistoryEntry === void 0 ? void 0 : selectHistoryEntry(_groups, consentGroups, _tcf);
    }
  }, [activeAction]);
}

export { useBannerActionType };